// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Grid,
//   Typography,
//   Chip,
//   CircularProgress,
//   Alert,
//   Dialog,
//   DialogContent,
//   IconButton,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import DeleteIcon from "@mui/icons-material/Delete";
// import SoftBox from "components/SoftBox";
// import SoftTypography from "components/SoftTypography";
// import SoftButton from "components/SoftButton";
// import DataTable from "examples/Tables/DataTable";
// import { getLeavePolicies, deleteLeavePolicy } from "api/leave";
// import CreateLeavePolicyForm from "../AddLeavePolicyForm ";  // removed trailing space

// const getPolicyColor = (leaveType, leaveCategory) => {
//   const colorMap = {
//     paid: {
//       fixed: "success",
//       experienced: "primary",
//     },
//     unpaid: {
//       fixed: "error",
//       experienced: "warning",
//     },
//   };
//   return colorMap[leaveType]?.[leaveCategory] || "default";
// };

// const getPolicyType = (leaveCategory) => {
//   if (leaveCategory === "fixed") return "Fixed";
//   if (leaveCategory === "experienced") return "Experience based";
//   return "Custom";
// };

// const getUnit = (leaveCreditUnit) => {
//   const unitMap = {
//     yearly: "Days",
//     monthly: "Days",
//     hours: "Hours",
//   };
//   return unitMap[leaveCreditUnit] || "Days";
// };

// function LeavePolicySettings() {
//   const [leavePolicies, setLeavePolicies] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [selectedPolicyId, setSelectedPolicyId] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [formMode, setFormMode] = useState("create");

//   const fetchLeavePolicies = async () => {
//     try {
//       setLoading(true);
//       setError(null);
//       const response = await getLeavePolicies();
//       if (response && response.data) {
//         setLeavePolicies(response.data);
//       }
//     } catch (err) {
//       setError("Failed to fetch leave policies");
//       console.error("Error fetching leave policies:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLeavePolicies();
//   }, []);

//   const handleRowClick = (policyId) => {
//     console.log("handleRowClick called for policyId:", policyId);
//     setSelectedPolicyId(policyId);
//     setFormMode("edit");
//     setShowModal(true);
//   };

//   const handleAddNew = () => {
//     console.log("Add New clicked");
//     setSelectedPolicyId(null);
//     setFormMode("create");
//     setShowModal(true);
//   };

//   const handleFormSuccess = () => {
//     setShowModal(false);
//     setSelectedPolicyId(null);
//     fetchLeavePolicies();
//   };

//   const handleFormCancel = () => {
//     setShowModal(false);
//     setSelectedPolicyId(null);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedPolicyId(null);
//   };

//   const handleDelete = async (policyId, policyName) => {
//     if (window.confirm(`Are you sure you want to delete the policy "${policyName}"?`)) {
//       try {
//         await deleteLeavePolicy(policyId);
//         setError(null);
//         fetchLeavePolicies();
//       } catch (err) {
//         setError("Failed to delete leave policy");
//         console.error("Error deleting leave policy:", err);
//       }
//     }
//   };

//   const tableData = {
//     columns: [
//       { Header: "Leave Policy", accessor: "leave_policy", align: "left" },
//       { Header: "Leave Code", accessor: "leave_code", align: "left" },
//       { Header: "Type", accessor: "type", align: "left" },
//       { Header: "Policy Type", accessor: "policy_type", align: "left" },
//       { Header: "Unit", accessor: "unit", align: "left" },
//       { Header: "Credit Days", accessor: "credit_days", align: "center" },
//       { Header: "Actions", accessor: "actions", align: "center" },
//     ],
//     rows: leavePolicies.map((policy) => ({
//       leave_policy: (
//         <Box
//           display="flex"
//           alignItems="center"
//           gap={1}
//           // Fallback: handle click on first cell
//           onClick={() => handleRowClick(policy.id)}
//         >
//           <Chip
//             size="small"
//             sx={{
//               backgroundColor: `${getPolicyColor(policy.leave_type, policy.leave_category)}.main`,
//             }}
//           />
//           <Typography fontSize={16}>{policy.leave_name}</Typography>
//         </Box>
//       ),
//       leave_code: (
//         <Chip
//           label={policy.leave_code}
//           variant="outlined"
//           size="small"
//           onClick={() => handleRowClick(policy.id)}
//         />
//       ),
//       type: (
//         <Chip
//           label={policy.leave_type}
//           variant="outlined"
//           sx={{
//             fontWeight: 500,
//             backgroundColor: policy.leave_type === "paid" ? "#e8f5e8" : "#ffe8e8",
//           }}
//           onClick={() => handleRowClick(policy.id)}
//         />
//       ),
//       policy_type: (
//         <Chip
//           label={getPolicyType(policy.leave_category)}
//           variant="outlined"
//           sx={{ fontWeight: 500 }}
//           onClick={() => handleRowClick(policy.id)}
//         />
//       ),
//       unit: (
//         <Typography
//           variant="button"
//           fontWeight="medium"
//           onClick={() => handleRowClick(policy.id)}
//         >
//           {getUnit(policy.leave_credit_unit)}
//         </Typography>
//       ),
//       credit_days: (
//         <Typography
//           variant="button"
//           fontWeight="medium"
//           onClick={() => handleRowClick(policy.id)}
//         >
//           {policy.leave_credit_days || 0}
//         </Typography>
//       ),
//       actions: (
//         <Box display="flex" gap={1} justifyContent="center">
//           <IconButton
//             color="error"
//             size="small"
//             onClick={(e) => {
//               e.stopPropagation();
//               handleDelete(policy.id, policy.leave_name);
//             }}
//             sx={{
//               "&:hover": {
//                 backgroundColor: "error.light",
//                 color: "error.dark",
//               },
//             }}
//           >
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       ),
//       onClick: () => handleRowClick(policy.id),
//     })),
//   };

//   if (loading) {
//     return (
//       <SoftBox display="flex" justifyContent="center" alignItems="center" height="50vh">
//         <CircularProgress />
//       </SoftBox>
//     );
//   }

//   console.log("showModal:", showModal);

//   return (
//     <SoftBox mb={3} sx={{ overflow: "auto" }}>
//       {error && (
//         <Grid item xs={12} pb={3}>
//           <Alert severity="error" onClose={() => setError(null)}>
//             {error}
//           </Alert>
//         </Grid>
//       )}

//       <Grid container spacing={3}>
//         <Grid item xs={12}>
//           <SoftBox display="flex" justifyContent="space-between" alignItems="center">
//             <SoftButton variant="gradient" color="info" size="medium" onClick={handleAddNew}>
//               Add Leave Policy
//             </SoftButton>
//           </SoftBox>
//         </Grid>

//         <Grid item xs={12}>
//           <SoftBox
//             sx={{
//               "& .MuiTableRow-root": {
//                 cursor: "pointer",
//                 "&:hover": {
//                   backgroundColor: "rgba(0, 0, 0, 0.04)",
//                 },
//               },
//             }}
//           >
//             <DataTable
//               table={tableData}
//               entriesPerPage={{ defaultValue: 10, entries: [5, 10, 15, 20, 25] }}
//               showTotalEntries={true}
//               pagination={{ variant: "gradient", color: "info" }}
//               isSorted={true}
//               noEndBorder={false}
//               onRowClick={(row) => {
//                 console.log("DataTable onRowClick:", row);
//                 const clickHandler = tableData.rows[row.index]?.onClick;
//                 if (clickHandler) clickHandler();
//               }}
//             />
//           </SoftBox>
//         </Grid>
//       </Grid>

//       <Dialog
//         open={showModal}
//         onClose={handleCloseModal}
//         maxWidth="md"
//         fullWidth
//         sx={{
//           "& .MuiDialog-paper": {
//             borderRadius: 2,
//           },
//         }}
//       >
//         <DialogContent sx={{ p: 0, position: "relative" }}>
//           <IconButton
//             aria-label="close"
//             onClick={handleCloseModal}
//             sx={{
//               position: "absolute",
//               right: 8,
//               top: 8,
//               color: (theme) => theme.palette.grey[500],
//               zIndex: 10,
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//           <Box sx={{ p: 3 }}>
//             <SoftTypography variant="h5" fontWeight="bold" mb={2} textAlign="center">
//               {formMode === "create" ? "Add New Leave Policy" : "Edit Leave Policy"}
//             </SoftTypography>

//             <CreateLeavePolicyForm
//               policyId={formMode === "edit" ? selectedPolicyId : null}
//               onSuccess={handleFormSuccess}
//               onCancel={handleFormCancel}
//             />
//           </Box>
//         </DialogContent>
//       </Dialog>
//     </SoftBox>
//   );
// }

// export default LeavePolicySettings;


import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Chip,
  CircularProgress,
  Alert,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import DataTable from "examples/Tables/DataTable";

import { getLeavePolicies, deleteLeavePolicy } from "api/leave";
import CreateLeavePolicyForm from "../AddLeavePolicyForm ";

import { useAuth } from "AuthContext";
import { hasPermission } from "permissionUtils";

/* ===================== HELPERS ===================== */

const getPolicyColor = (leaveType, leaveCategory) => {
  const colorMap = {
    paid: { fixed: "success", experienced: "primary" },
    unpaid: { fixed: "error", experienced: "warning" },
  };
  return colorMap[leaveType]?.[leaveCategory] || "default";
};

const getPolicyType = (leaveCategory) => {
  if (leaveCategory === "fixed") return "Fixed";
  if (leaveCategory === "experienced") return "Experience based";
  return "Custom";
};

const getUnit = (leaveCreditUnit) => {
  const unitMap = { yearly: "Days", monthly: "Days", hours: "Hours" };
  return unitMap[leaveCreditUnit] || "Days";
};

/* ===================== COMPONENT ===================== */

function LeavePolicySettings() {
  const { userPermission = [] } = useAuth();

  /* -------- PERMISSIONS -------- */
  const canView = hasPermission(
    "Settings.LeaveTracker.LeavePolicy",
    userPermission
  );

  const canAdd = hasPermission(
    "Settings.LeaveTracker.LeavePolicy.AddPolicy",
    userPermission
  );

  const canEdit = hasPermission(
    "Settings.LeaveTracker.LeavePolicy.EditPolicy",
    userPermission
  );

  const canDelete = hasPermission(
    "Settings.LeaveTracker.LeavePolicy.DeletePolicy",
    userPermission
  );

  /* -------- STATE -------- */
  const [leavePolicies, setLeavePolicies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [selectedPolicyId, setSelectedPolicyId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formMode, setFormMode] = useState("create");

  /* -------- FETCH -------- */
  const fetchLeavePolicies = async () => {
    try {
      setLoading(true);
      const response = await getLeavePolicies();
      setLeavePolicies(response?.data || []);
    } catch {
      setError("Failed to fetch leave policies");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (canView) fetchLeavePolicies();
  }, [canView]);

  /* -------- HANDLERS -------- */
  const handleRowClick = (policyId) => {
    if (!canEdit) return;
    setSelectedPolicyId(policyId);
    setFormMode("edit");
    setShowModal(true);
  };

  const handleAddNew = () => {
    if (!canAdd) return;
    setSelectedPolicyId(null);
    setFormMode("create");
    setShowModal(true);
  };

  const handleFormSuccess = () => {
    setShowModal(false);
    setSelectedPolicyId(null);
    fetchLeavePolicies();
  };

  const handleDelete = async (policyId, policyName) => {
    if (!canDelete) return;

    if (window.confirm(`Delete policy "${policyName}"?`)) {
      try {
        await deleteLeavePolicy(policyId);
        fetchLeavePolicies();
      } catch {
        setError("Failed to delete leave policy");
      }
    }
  };

  /* -------- TABLE -------- */
  const tableData = {
    columns: [
      { Header: "Leave Policy", accessor: "leave_policy" },
      { Header: "Leave Code", accessor: "leave_code" },
      { Header: "Type", accessor: "type" },
      { Header: "Policy Type", accessor: "policy_type" },
      { Header: "Unit", accessor: "unit" },
      { Header: "Credit Days", accessor: "credit_days", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],
    rows: leavePolicies.map((policy) => ({
      leave_policy: (
        <Box display="flex" alignItems="center" gap={1}
          onClick={() => handleRowClick(policy.id)}
        >
          <Chip size="small" color={getPolicyColor(policy.leave_type, policy.leave_category)} />
          <SoftTypography color="text" variant="h6">{policy.leave_name}</SoftTypography>
        </Box>
      ),
      leave_code: policy.leave_code,
      type: policy.leave_type,
      policy_type: policy.leave_category,
      unit: <>{getUnit(policy.leave_credit_unit)}</>,
      credit_days: <>{policy.leave_credit_days || 0}</>,
      actions: (
        canDelete && (
          <IconButton
            color="error"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              handleDelete(policy.id, policy.leave_name);
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        )
      ),
      onClick: () => handleRowClick(policy.id),
    })),
  };

  /* -------- GUARDS -------- */
  if (!canView) return null;

  if (loading) {
    return (
      <SoftBox display="flex" justifyContent="center" height="50vh">
        <CircularProgress />
      </SoftBox>
    );
  }

  return (
    <SoftBox mb={3}>
      {error && (
        <Alert severity="error" onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <Grid container spacing={3}>
        <Grid item xs={12}>
          {canAdd && (
            <SoftButton variant="gradient" color="info" onClick={handleAddNew}>
              Add Leave Policy
            </SoftButton>
          )}
        </Grid>

        <Grid item xs={12}>
          <DataTable
            table={tableData}
            entriesPerPage={{ defaultValue: 10 }}
            showTotalEntries
            isSorted
            onRowClick={(row) => {
              const fn = tableData.rows[row.index]?.onClick;
              if (fn) fn();
            }}
          />
        </Grid>
      </Grid>

      {/* MODAL */}
      <Dialog open={showModal} maxWidth="md" fullWidth>
        <DialogContent>
          <IconButton
            onClick={() => setShowModal(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <SoftTypography variant="h5" mb={2} textAlign="center">
            {formMode === "create" ? "Add Leave Policy" : "Edit Leave Policy"}
          </SoftTypography>

          <CreateLeavePolicyForm
            policyId={formMode === "edit" ? selectedPolicyId : null}
            onSuccess={handleFormSuccess}
            onCancel={() => setShowModal(false)}
          />
        </DialogContent>
      </Dialog>
    </SoftBox>
  );
}

export default LeavePolicySettings;
